import script from "./EditBucketOptionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditBucketOptionModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditBucketOptionModal.vue?vue&type=style&index=0&id=3666e8f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3666e8f8"]])

export default __exports__